var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.61,
    height: 21.789,
    viewBox: "0 0 19.61 21.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.163,21.61H8.447a3.268,3.268,0,0,1-3.268-3.268V7.447A1.089,1.089,0,1,0,3,7.447V18.342a5.447,5.447,0,0,0,5.447,5.447h8.716a1.089,1.089,0,1,0,0-2.179ZM22.61,9.561a1.427,1.427,0,0,0-.065-.294v-.1a1.166,1.166,0,0,0-.207-.305h0L15.8,2.327h0A1.166,1.166,0,0,0,15.5,2.12h-.1L15.049,2H10.626A3.268,3.268,0,0,0,7.358,5.268V16.163a3.268,3.268,0,0,0,3.268,3.268h8.716a3.268,3.268,0,0,0,3.268-3.268v-6.6ZM16.074,5.715,18.9,8.537H17.163a1.089,1.089,0,0,1-1.089-1.089Z",
    transform: "translate(-3 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f39e26b824e6efc238e2af940165c54c.svg";
export { ForwardRef as ReactComponent };